// src/components/Header.jsx
import { Link, NavLink } from "react-router-dom";
import "../index.css";

export default function Header() {
    return (
      <header className="header">
        <img src="/LC_Cloud_Left.png" alt="" className="ornament left" />
        <div className="logo">
          <Link to="/"><img src="/LCLogo2.png" alt="LC Logo" className="logo-img" /></Link>
        </div>
        <nav className="nav">
          <NavLink to="/" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>Home</NavLink>
          <NavLink to="/menu" className="nav-link nav-cta">Menu</NavLink>
          <NavLink to="/about" className={({isActive}) => `nav-link ${isActive ? "active" : ""}`}>About Us</NavLink>
        </nav>
        <img src="/LC_Cloud_Right.png" alt="" className="ornament right" />
      </header>
    );
  }
  